<template>
  <WidgetWrapper
    lg="6"
    :title="$t('delivery.dashboard.deliveryAchievement')"
    :tooltip-text="$t('delivery.dashboard.deliveryAchievementTooltip')"
  >
    <FormulateInput
      type="date-picker"
      v-model="period"
      format="DD MMM YYYY"
      value-type="YYYY-MM-DDTHH:mm:ssZ"
      range-separator=" - "
      range
      class="p-0 h-auto mb-4"
      :placeholder="$t('global.action.selectDate')"
      :lang="datePickerLang"
      @input="handleChangeDateRange($event)"
      :confirm="true"
      :draft="true"
      :cancel="true"
      :confirmText="$t('global.apply')"
      :shortcuts="datepickerShorcuts"
    ></FormulateInput>
    <b-row class="gy-3">
      <b-col cols="12" v-for="(status, id) in statusKeys" :key="id">
        <StatusCard
          :status="status"
          :data="achievementData[status]"
          :loading="loading"
          @click="$emit('showDetail', status)"
        />
      </b-col>
    </b-row>
  </WidgetWrapper>
</template>

<script>
import StatusCard from '../components/StatusCard.vue'
import WidgetWrapper from '../components/WidgetWrapper.vue'

import datePickerLang from '../lib/constants/date-picker-lang'

import { getDeliveryAchievementWidget } from '@/services/rest-api/lib/dashboard/delivery-widget'
import { formatEndDateFilter } from '../helpers/formatTime'

export default {
  components: {
    StatusCard,
    WidgetWrapper,
  },
  emits: ['showDetail', 'changeDateRange'],
  data() {
    return {
      achievementData: {},
      loading: false,
      period: [],
    }
  },
  computed: {
    statusKeys() {
      return ['DELIVERED', 'CANCELED']
    },
    isPeriodNotEmpty() {
      return this.period.length > 0 && this.period.every((date) => date != null)
    },
    datePickerLang() {
      return datePickerLang()
    },
    datepickerShorcuts() {
      return [
        {
          text: this.$t('global.time.today'),
          onClick: () => {
            const startDate = new Date()
            const endDate = new Date()

            startDate.setHours(0, 0, 0)
            endDate.setHours(23, 59, 59)

            return [startDate, endDate]
          },
        },
        {
          text: this.$t('global.time.yesterday'),
          onClick: () => {
            const startDate = new Date()
            const endDate = new Date()

            startDate.setDate(startDate.getDate() - 1)
            startDate.setHours(0, 0, 0)

            endDate.setDate(endDate.getDate() - 1)
            endDate.setHours(23, 59, 59)

            return [startDate, endDate]
          },
        },
        {
          text: this.$t('global.time.last7Days'),
          onClick: () => {
            const startDate = new Date()
            const endDate = new Date()

            startDate.setDate(startDate.getDate() - 7)
            startDate.setHours(0, 0, 0)
            endDate.setHours(23, 59, 59)

            return [startDate, endDate]
          },
        },
        {
          text: this.$t('global.time.last30Days'),
          onClick: () => {
            const startDate = new Date()
            const endDate = new Date()

            startDate.setDate(startDate.getDate() - 30)
            startDate.setHours(0, 0, 0)
            endDate.setHours(23, 59, 59)

            return [startDate, endDate]
          },
        },
        {
          text: this.$t('global.time.thisMonth'),
          onClick: () => {
            const startDate = new Date()
            const endDate = new Date()

            startDate.setDate(1)
            startDate.setHours(0, 0, 0)
            endDate.setHours(23, 59, 59)

            return [startDate, endDate]
          },
        },
        {
          text: this.$t('global.time.lastMonth'),
          onClick: () => {
            const startDate = new Date()
            startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * startDate.getDate())
            startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * (startDate.getDate() - 1))
            startDate.setHours(0, 0, 0)

            const endDate = new Date()
            endDate.setTime(endDate.getTime() - 3600 * 1000 * 24 * endDate.getDate())
            endDate.setHours(23, 59, 59)

            return [startDate, endDate]
          },
        },
      ].map((shortcut) => ({ ...shortcut, value: shortcut.onClick }))
    },
  },
  mounted() {
    this.showData()
  },
  methods: {
    async showData() {
      this.loading = true

      const params = {}

      if (this.isPeriodNotEmpty) {
        params['filters'] = `action_on between (${this.period[0]} ${formatEndDateFilter(
          this.period[1]
        )})`
      }
      const res = await getDeliveryAchievementWidget(params)

      if (res.errors) return

      this.achievementData = res.data?.status
      this.loading = false
    },
    handleChangeDateRange(value) {
      this.showData()
      this.$emit('changeDateRange', this.isPeriodNotEmpty ? value : [])
    },
  },
}
</script>

<style scoped lang="scss">
:deep(.formulate-input-wrapper) {
  max-width: 210px;
}
</style>
